import {
	Button as RNButton,
	type ButtonProps as RNButtonProps,
} from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

export type ButtonProps = RNButtonProps;

export const Button = ({ labelStyle, ...props }: ButtonProps) => {
	const theme = useAppTheme();

	return (
		<RNButton
			{...props}
			labelStyle={[
				theme.componentOverrides?.button?.labelStyle,
				labelStyle,
				// {
				// 	letterSpacing: 2,
				// },
			]}
		/>
	);
};
